import React, { useEffect, useState } from 'react'
import Chart from '../../Components/Chart/Chart'
import PieChart from '../../Components/Chart/PieChart'
import { Button, Card } from 'react-bootstrap'
import { DatePicker, Message, Notification, Space } from '@arco-design/web-react';
import { ManageApis } from '../../AppServices/ManageApi';
import moment from 'moment';
import { async } from 'q';
import { object } from 'prop-types';
import Loader from '../../Components/LoaderComponent/Loader';
import DataTable from '../../Components/DataTable/DataTable';
import axios from 'axios';
import { getLocalStorage } from '../../Functions/Utils';
import AlertBox from '../../Components/AlertBox/AlertBox';
import dayjs from 'dayjs';

const dev = false;
let lcount = 0;

var sd = '';
var ed = '';
let firstrun = false;

function HitOverview() {
    const [clientsNameList, setClientsNameList] = useState([{ id: 'all', name: 'All' }]);
    const [serviceNameList, setServiceNameList] = useState([{ id: 'all', serviceName: 'All' }]);
    const [isVisible, setisVisible] = useState(false)
    const [currentTimeIntervel, setcurrentTimeIntervel] = useState('all')
    const [currentClient, setcurrentClient] = useState('')
    const [currentService, setcurrentService] = useState('')
    const [dateRange, setDateRange,] = useState(['']);
    const [filterDate, setFilterDate, filterDateref] = useState({});
    const [tabelData, settabelData] = useState([])
    // const [statusCodes, setStatusCodes] = useState([])
    const statusCodes = [200, 406, 409, 422]
    const [statusCodeChart, setStatusCodeChart] = useState([])
    const [loader, setloader] = useState(false);
    const [loader1, setloader1] = useState(false);
    const [loader2, setloader2] = useState(false);
    const [data, setData] = useState([])
    const [TableLoader, setTableLoader] = useState(false);
    const [currentPage, setcurrentPage] = useState(1);
    const [currentdate, setCurrentdate] = useState('')
    const [clientHits, setClientHits] = useState(0);
    const [allHitByMonth, setAllHitByMonth] = useState([])
    const [clientServiceList, setclientServiceList] = useState([])
    const [loaderCount, setLoaderCount] = useState(0)
    const [exportStartDate, setExportStartDate] = useState('')
    const [exportEndDate, setExportEndDate] = useState('')
    const [exportCurrentClient, setExportCurrentClient] = useState('')
    const [exportCurrentService, setExportCurrentService] = useState('')
    const AlertinitialValue = {
        show: false,
        message: "",
        isfalse: false,
        isSuccess: false,
        isWarning: false,
    };
    const [showAlert, setShowAlert] = useState(AlertinitialValue);
    const [StatusCount, setStatusCount] = useState(
        {
            200: 0,
            406: 0,
            409: 0,
            422: 0
        }
    )
    const [statusCodeValues, setStatusCodeValues] = useState({
        200: 0,
        406: 0,
        409: 0,
        422: 0,
    }
    )
    const [codes, setCodes] = useState([])

    useEffect(() => {
     
        if (lcount > 0) {
            if (!loader) {
                setloader(true)
            }
        }
        else {
            setloader(false)
        }
    }, [lcount])

    const columns = [
        {
            title: 'Status Code',
            dataIndex: 'statuscode',
            key: 'statuscode',
            headerCellStyle: {
                backgroundColor: "var(--mastercolor2)",
                color: "#fff",
            },
        },
        {
            title: 'API Call',
            dataIndex: 'apicall',
            key: 'apicall',
            headerCellStyle: {
                backgroundColor: "var(--mastercolor2)",
                color: "#fff",
            },
        },
        {
            title: 'Number of Execution',
            dataIndex: 'noofexecution',
            key: 'noofexecution ',
            headerCellStyle: {
                backgroundColor: "var(--mastercolor2)",
                color: "#fff",
            },
        },
        {
            title: 'Number of Pages',
            dataIndex: 'noofpage',
            key: 'noofpage',
            headerCellStyle: {
                backgroundColor: "var(--mastercolor2)",
                color: "#fff",
            },
        },
    ]

    // const codes = [
    //   {
    //     "httpStatusCode": 200,
    //     "count": 4947578
    //   },
    //   {
    //     "httpStatusCode": 422,
    //     "count": 5107
    //   },
    //   {
    //     "httpStatusCode": 406,
    //     "count": 3685
    //   }
    // ]


    useEffect(() => {

        //console.log('current codes  -- >', codes)
        //console.log('filtered code', codes.filter(code => code.httpStatusCode === 200))


        // getHitCount
        // let statusCode200 = codes.filter(code => code.httpStatusCode === 200)
        // let statusCode406 = codes.filter(code => code.httpStatusCode === 406)
        // let statusCode409 = codes.filter(code => code.httpStatusCode === 409)
        // let statusCode422 = codes.filter(code => code.httpStatusCode === 422)

        // let values = {
        //     200: statusCode200[0]?.count,
        //     406: statusCode406[0]?.count,
        //     409: statusCode409[0]?.count,
        //     422: statusCode422[0]?.count
        // }
        const values = tabelData.reduce((acc, row) => {
            acc[row.statuscode] = row.apicall;
            return acc;
        }, {});


        setStatusCodeValues(values)

    }, [
        // codes
        tabelData
    ])

    // useEffect(() => {
    //     ""
    //     //console.log(statusCodeValues)
    // }, [statusCodeValues])





    // //console.log(statusCode200)

    // const columns = [
    //   {
    //     title: "Status Code"
    //     dataIndex: ""
    //   }
    // ]

    useEffect(() => {

        getClientsListData()
        getAllHitOfparameter()
        if (getLocalStorage("user_roll") == "Admin") {

            getServiceListDetails()
        }
        statusCodes.map(code => {
            getHitsCountByStatusCode(code)
        })
        getAllHitByMonth()
        getHitCount()
        getAllClientServices()
    }, [])


    const getHitsCountByStatusCodeDashboard = async (statusCode) => {
        try {
                    // setloader2(true)
                    setLoaderCount(loaderCount + 1)
                    lcount = lcount + 1
            
                    let paramClient = currentClient ? `ClientIds=${currentClient}` : ''
                    let sdate = startDate ? `&StartDate=${startDate}` : ''
                    let edate = endDate ? `&EndDate=${endDate}` : ''
                    let response = await ManageApis('get', global.GetHitsCountByStatusCode + paramClient + sdate + edate + `&HttpStatusCodes=${statusCode}`)
                    if (response.message == 'Success') {
                        //console.log(response)
                        let count = response?.response_data[0]?.count
                        //console.log(count)
                        if (response?.response_data.length > 1) {
                            const total = response?.response_data.reduce((sum, item) => sum + item.count, 0);
                            // setloader2(false)
                         
                            setLoaderCount(loaderCount - 1)
                            lcount = lcount - 1
            
                            return total;
                        }
                        else {
                            // setloader2(false)
                            setLoaderCount(loaderCount - 1)
                            lcount = lcount - 1
                            return count == undefined ? 0 : count
                        }
                    }
                    else {
                        // setloader2(false)
                        setLoaderCount(loaderCount - 1)
                        lcount = lcount - 1
                        //console.log(response)
                        return 0
                    }
        } catch (error) {
            setLoaderCount(loaderCount - 1)
            lcount = lcount - 1
        }
    }

    const timeIntervals = [
        { id: 'all', name: 'All' },
        { id: 'this_week', name: 'This Week' },
        { id: 'this_month', name: 'This Month' },
        { id: 'last_month', name: 'Last Month' },
        { id: 'last_3_months', name: 'Last 3 Months' },
        { id: 'this_year', name: 'This Year' },
        { id: 'custom', name: 'Custom' }
    ];

    const getServiceListDetails = async (selectedClient = '') => {
  
        // setloader(true)
        ""
        setLoaderCount(loaderCount + 1)
        lcount = lcount + 1

        if (dev) {
            let response = await axios.get("http://localhost:3001" + global.getServicesByUser)
            const serviceList = response?.data.map(row => ({
                name: row.name,
                id: row.id,
            }));
            setServiceNameList([{ id: 'all', serviceName: 'All' }, ...serviceList]);
            setloader(false)
        }
        else {
            try {
             
                let param = getLocalStorage("user_roll") == "Admin" ? "" : `?userId=${getLocalStorage("clientId")}&clientId=${selectedClient}`
                let response = await ManageApis("get", global.getServicesByUser + param);
                //console.log(response);

                if (response.message === "Success") {
                 
                    const serviceList = response?.response_data.map((row) => ({
                      serviceName: row.name,
                      id: row.id,
                    }));
                    
                    setServiceNameList([{ id: 'all', serviceName: 'All' }, ...serviceList]);
                    // setloader(false)
                    setLoaderCount(loaderCount - 1)
                    lcount = lcount - 1


                } else {
                    // setloader(false)
                    setLoaderCount(loaderCount - 1)
                    lcount = lcount - 1

                    //console.log(response)
                    Message.error(response?.message)
                }
            } catch (error) {
                // setloader(false)
                setLoaderCount(loaderCount - 1)
                lcount = lcount - 1

                //console.log(error);
            }
        }
    };

    const getClientsListData = async () => {
     
        // setloader(true)
        setLoaderCount(loaderCount + 1)
        lcount = lcount + 1

        if (dev) {
            let response = await axios.get("http://localhost:3001" + global.getClientsList)

            const clientList = response?.data.map(row => ({
                name: row.name,
                id: row.id,
            }));
            setClientsNameList([{ id: 'all', name: 'All' }, ...clientList]);
            // setloader(false)
            setLoaderCount(loaderCount - 1)
            lcount = lcount - 1

        }
        else {
            try {

                let param = getLocalStorage("user_roll") == "Admin" ? "" : `?UserId=${getLocalStorage("clientId")}`
                let response = await ManageApis("get", global.getClientsList + param);
                //console.log(response);

                if (response.message === "Success") {
                    const clientList = response?.response_data.map(row => ({
                        name: row.name,
                        id: row.id,
                    }));
                    if (clientList.length == 1) {
                     
                       setClientsNameList([{ id: 'all', name: 'All' }, ...clientList]);
                        setcurrentClient(clientList[0]?.id)
                        getServiceListDetails(clientList[0]?.id)
                    } else {

                        setClientsNameList([{ id: 'all', name: 'All' }, ...clientList]);
                    }
                    // setloader(false)
                    setLoaderCount(loaderCount - 1)
                    lcount = lcount - 1


                } else {
                    // setloader(false)
                    setLoaderCount(loaderCount - 1)
                    lcount = lcount - 1

                    //console.log(response)
                    Message.error(response?.message)
                }
            } catch (error) {
                // setloader(false)
                setLoaderCount(loaderCount - 1)
                lcount = lcount - 1


                //console.log(error)
            }
        }
    };

    const handleClient = (e) => {
        setCurrentdate('')
        setStatusCodeChart([])

        if (e.target.value == 'all') {
            setcurrentClient('')
        } else {
            setcurrentClient(e.target.value)
            getServiceListDetails(e.target.value)
        }    ///api call

    }

    useEffect(() => {
        if (firstrun) {
            //console.log('as')
            getAllHitOfparameter()
            statusCodes.map(code => {
                getHitsCountByStatusCode(code)
            })
            getHitCount()
        } else {
            firstrun = true
        }

    }, [currentClient, currentService])



    const handleService = (e) => {
        if (e.target.value == 'all') {
            setcurrentService('')
        } else {
            setcurrentService(e.target.value)
        }    // getAllHitOfparameter()
        setStatusCodeChart([])

    }

    var startDate = '';
    var endDate = "";

    const handleDateselect = (e) => {
        setCurrentdate(e.target.value)
        //console.log(e.target.value)
        if (e.target.value == 'this_year') {
            setisVisible(false);
            endDate = moment().endOf('year').format('YYYY-MM-DD');
            startDate = moment().startOf('year').format('YYYY-MM-DD');
        }
        else if (e.target.value == 'all') {
            setisVisible(false);
            endDate = "";
            startDate = ""
        }
        else if (e.target.value == 'this_month') {
            setisVisible(false);
            endDate = moment().format('YYYY-MM-DD');
            startDate = moment().startOf('month').format('YYYY-MM-DD');
        }
        else if (e.target.value == 'this_week') {
            setisVisible(false);
            endDate = moment().format('YYYY-MM-DD');
            startDate = moment().startOf('week').format('YYYY-MM-DD');
        }
        else if (e.target.value == 'last_month') {
            setisVisible(false);
            endDate = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
            startDate = moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD');

        }
        else if (e.target.value == "last_3_months") {
            setisVisible(false);
            endDate = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
            startDate = moment().subtract(3, 'months').startOf('month').format('YYYY-MM-DD');

        }
        else if (e.target.value == "custom") {
            //console.log('hel')
            setisVisible(true);
        }
        setExportStartDate(startDate)
        setExportEndDate(endDate)
        setExportCurrentClient(currentClient)
        setExportCurrentService(currentService)

        if (e.target.value != "custom") {
            //api call
            getAllHitOfparameter()
            getHitCount()

            getStatusCode()
        }

    }

    useEffect(() => {

        getStatusCode()

    }, [currentClient])


    const handleFilter = () => {

        if (dateRange) {


            //console.log(dateRange)
            startDate = sd;
            endDate = ed;
            setExportStartDate(startDate)
            setExportEndDate(endDate)
            setExportCurrentClient(currentClient)
            setExportCurrentService(currentService)
            // //console.log("custom", filterDateref.current)

            //api call
            getAllHitOfparameter()

            getStatusCode()

            // statusCodes.map(code => {
            //   getHitsCountByStatusCode(code)
            // })
            
        }
        else {
            Notification.error("please select date")
            //console.log(dateRange)
        }





    }

    const onDateRangeChange = (dateRange) => {   //set value of rangepicker to usestate
        //console.log(dateRange)
        if (dateRange) {
            setDateRange(returnMomentDateRange(dateRange[0], dateRange[1]));


            var startD = dateRange[0]
            var endD = dateRange[1]
            sd = convertDate(startD)
            ed = convertDate(endD)

        }
        //console.log("sd", sd, ed)

    };
    const returnMomentDateRange = (start, finish) => {   //to format date 

        return [moment(start, "YYYY-MM-DD"), moment(finish, "YYYY-MM-DD")];
    };
    const convertDate = (startD) => {
        function pad(s) { return (s < 10) ? '0' + s : s; }
        var d = new Date(startD)
        return [d.getFullYear(), pad(d.getMonth() + 1), pad(d.getDate())].join('-')
    }


    // need to complete
    const getHitCount = async () => {
        // setloader(true)
        setLoaderCount(loaderCount + 1)
        lcount = lcount + 1

        setCodes([])
        let client = currentClient !== '' ? `&ClientIds=${currentClient}` : ''
        let service = currentService !== '' ? `&ServiceIds=${currentService}` : ''
        let sdate = startDate ? `StartDate=${startDate}` : ''
        let edate = endDate ? `&EndDate=${endDate}` : ''
        //console.log('gethit params --->', client + service + sdate + edate)
        if (dev) {
            let response = await axios.get("http://localhost:3001" + global.getHitCount + sdate + edate + client + service)
            setCodes(response.data)
            setloader(false)
        }
        {
            let response = await ManageApis('get', global.getHitCount + sdate + edate + client + service)
            if (response.message == 'Success') {
                setCodes(response.response_data)
                // setloader(false)
                setLoaderCount(loaderCount - 1)
                lcount = lcount - 1

                //console.log('gethit status codes -- >', response.response_data)
            }
            else {
                // setloader(false)
                setLoaderCount(loaderCount - 1)
                lcount = lcount - 1

                //console.log('error -->', response)
            }
        }
    }

    const getAllHitOfparameter = async () => {
     
        // setloader1(true)
        setLoaderCount(loaderCount + 1)
        lcount = lcount + 1

        // //console.log(currentClient)
        let client = currentClient !== '' ? `clientid=${currentClient}` : ''
        let service = currentService !== '' ? `&serviceid=${currentService}` : ''
        let sdate = startDate ? `&StartDate=${startDate}` : ''
        let edate = endDate ? `&EndDate=${endDate}` : ''
        if (dev) {
            try {
                let response = await axios.get("http://localhost:3001" + global.getAllHitOfparameter + client + service + sdate + edate)
                setloader1(false)
                //console.log(response)
                //console.log(response.data)
                settabelData(response.data.map(row => ({
                    apicall: row.apicall,
                    noofexecution: row.noofexecution,
                    noofpage: row.noofpage,
                    statuscode: row.statuscode
                })))//map
            } catch (e) {
                //console.log("axois error =>", e)
                Message.error('Something went wrong')
                setloader1(false)

            }
        }
        else {

            let response = await ManageApis('get', global.getAllHitOfparameter + client + service + sdate + edate)
            if (response?.message == 'Success') {
                // setloader1(false)
                setLoaderCount(loaderCount - 1)
                lcount = lcount - 1

                //console.log(response)
                //console.log(response.response_data)
                settabelData(response.response_data.map(row => ({
                    apicall: row.apicall,
                    noofexecution: row.noofexecution,
                    noofpage: row.noofpage,
                    statuscode: row.statuscode
                })))//map
            }
            else {
                // setloader1(false)
                setLoaderCount(loaderCount - 1)
                lcount = lcount - 1

                //console.log(response)
                Message.error('Something went wrong')
            }
        }
    }

    // useEffect(() => {
    //   setStatusCodes(tabelData.map(row => (row.statuscode)))

    // }, [tabelData])


    // useEffect(() => {
    //   code200 = Object.values(statusCodeChart.codes200)
    //   // if (code200 && Array.isArray(code200)) {
    //   //   //console.log(code200)
    //   //   monthValues200 = code200.map(item => item.month)
    //   // }
    //   code406 = statusCodeChart[406]
    //   code409 = statusCodeChart[409]
    //   code422 = statusCodeChart[422]
    // }, [setStatusCodeChart])

    useEffect(() => {
        //console.log('status code chart -->', statusCodeChart)

    }, [statusCodeChart])

    function onChangeTable(pagination) {
        //console.log(pagination);
        const { current, pageSize } = pagination;
        setTableLoader(true);
        // setServiceKeyTableData(dataTableInitialLoader(columns));
        setStatusCodeChart([]);

        setTimeout(() => {

            setStatusCodeChart(
                data.slice((current - 1) * pageSize, current * pageSize)
            );

            setcurrentPage(current);
            setTableLoader(false);
        }, 2000);
    }
    useEffect(() => {
     
        setClientHits(StatusCount[200] + StatusCount[406] + StatusCount[409] + StatusCount[422])
    }, [StatusCount]
    )
    const getHitsCountByStatusCode = async (code) => {
        setStatusCodeChart([])
        // setloader2(true)
        setLoaderCount(loaderCount + 1)
        lcount = lcount + 1

        let codeparam = `code=${code}`
        let client = currentClient !== '' ? `&clientid=${currentClient}` : ''
        let service = currentService !== '' ? `&serviceid=${currentService}` : ''
        //console.log(codeparam + client + service)
        if (dev) {
            let response = await axios.get("http://localhost:3001/" + global.getStatusCodeasParameter + codeparam + client + service)
            setStatusCodeChart(prev => ([...prev, { code, data: response?.data }]))
            setData(prev => ([...prev, { code, data: response?.data }]))
            setloader2(false)
        }
        else {
            let response = await ManageApis('get', global.getStatusCodeasParameter + codeparam + client + service)
            if (response.message == "Success") {
                //console.log(response)
                setStatusCodeChart(prev => ([...prev, { code, data: response?.response_data }]))
                setData(prev => ([...prev, { code, data: response?.response_data }]))
                // setloader2(false)
                setLoaderCount(loaderCount - 1)
                lcount = lcount - 1

            }
            else {
                // setloader2(false)
                setLoaderCount(loaderCount - 1)
                lcount = lcount - 1

                //console.log(response)
            }
        }
    }

    const handleClear = () => {
        setClientsNameList([{ id: 'all', name: 'All' }]);
        setServiceNameList([{ id: 'all', serviceName: 'All' }]);
        setisVisible(false);
        setcurrentTimeIntervel('all');
        setcurrentClient('');
        setcurrentService('');
        setDateRange(['']);
        setFilterDate({});
        settabelData([]);
        setStatusCodeChart([]);
        setloader(false);
        setCurrentdate('')
        setExportStartDate('')
        setExportEndDate('')
        setExportCurrentClient('')
        setExportCurrentService('')


        getClientsListData();
        // getServiceListDetails()
        getAllHitOfparameter();

        statusCodes.forEach(code => {
            getHitsCountByStatusCode(code);
        });
    }

    const handleDownload = async () => {
        const params = {
            clientid: currentClient,
            serviceid: currentService,
            startDate: exportStartDate || '',
            endDate: exportEndDate || '',
        }
        // let result = await ManageApis("get", global.overviewDowndload)
        // if (result.message == "Success") {
        // //console.log("----------------- success -----------------------")
        // //console.log(result.response_data)
        try {

            // let client = currentClient !== '' ? `&clientid=${currentClient}` : ''
            // let service = currentService !== '' ? `&serviceid=${currentService}` : ''
            // let sdate = exportStartDate ? `startDate=${startDate}` : ''
            // let edate = exportEndDate ? `&endDate=${endDate}` : ''
            // const params = {
            //     clientid: currentClient,
            //     serviceid: currentService,
            //     startDate: exportStartDate || '',
            //     endDate: exportEndDate || '',
            // }
            //old base-api
            // const response = await axios.get('https://api-uat-demo.pixl.ai/api/Hit/GetSummaryReport', {
            //     responseType: 'arraybuffer',
            //     params
            // });
            const response = await axios.get(global.uploadData + '/Hit/GetSummaryReport', {
                responseType: 'arraybuffer',
                headers: {
                    Authorization: "Bearer " + getLocalStorage("access_token"),
                },
                params

            });
            if (response.status == 200) {
                const filename = "Downloadfile.xlsx"
                const blob = new Blob([response.data], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                });

                // Create a download link and trigger a click event to start the download
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = filename;
                link.click();
            }
            else {
                setShowAlert((pre) => ({
                    ...pre,
                    show: true,
                    message: "Something went wrong",
                    isSuccess: false,
                    isfalse: true,
                }));
            }

        }
        catch (e) {
            setShowAlert((pre) => ({
                ...pre,
                show: true,
                message: "Something went wrong",
                isSuccess: false,
                isfalse: true,
            }));
        }
        // }
        // else {
        //     //console.log("----------------- error -----------------------")

        // }
    }

    const getStatusCode = async () => {
     
        let status200 = await getHitsCountByStatusCodeDashboard(200)
        let status406 = await getHitsCountByStatusCodeDashboard(406)
        let status409 = await getHitsCountByStatusCodeDashboard(409)
        let status422 = await getHitsCountByStatusCodeDashboard(422)
        setStatusCount({ 200: status200, 406: status406, 409: status409, 422: status422 })
    }

    const getAllHitByMonth = async () => {
        // setloader(true)
        setLoaderCount(loaderCount + 1)
        lcount = lcount + 1

        let response = await ManageApis('get', global.getAllHitBymonth)
        if (response.message === "Success") {
            //console.log(response)
            setAllHitByMonth(response.response_data)
            // setloader(false)
            setLoaderCount(loaderCount - 1)
            lcount = lcount - 1


        }
        else {
            // setloader(false)
            setLoaderCount(loaderCount - 1)
            lcount = lcount - 1

            //console.log('error --- >', response)
        }
    }

    const getAllClientServices = async () => {
        // setloader(true)
        setLoaderCount(loaderCount + 1)
        lcount = lcount + 1

        let response = await ManageApis('get', global.getAllClientServices);
        if (response.message === "Success") {
            //console.log(response)
            setclientServiceList(response?.response_data.map(row => ({
                serviceName: row.serviceName,
                count: row.count,
            })))
            // setloader(false)
            setLoaderCount(loaderCount - 1)
            lcount = lcount - 1

        }
        else {
            // setloader(false)
            setLoaderCount(loaderCount - 1)
            lcount = lcount - 1

            //console.log(response)
        }
    }
    const extractChartData = () => {
        if (allHitByMonth.length === 0) {
            return { categories: [], series: [] };
        }
        const categories = allHitByMonth.map(item => item?.month);

        const series = Object.keys(allHitByMonth[0])
            .filter(key => key !== 'month')
            .map(key => ({
                name: key,
                data: allHitByMonth.map(item => item[key])
            }));

        return { categories, series };
    };

    const { categories, series } = extractChartData();
    const serviceNames = clientServiceList.map(item => item.serviceName);
    const counts = clientServiceList.map(item => item.count);
    return (
        <>
            {loader && <Loader />}
            {loader1 && <Loader />}
            {loader2 && <Loader />}
            <AlertBox
                show={showAlert.show}
                message={showAlert.message}
                enableFailIcon={showAlert.isfalse}
                enableSuccessIcon={showAlert.isSuccess}
                enableWarningIcon={showAlert.isWarning}
                handlecancel={() => setShowAlert(AlertinitialValue)}
            />
            <div className='px-3 overflow-auto hitDashBoard scrollbar1'>
                <div className='mb-4 pt-2'>
                    <div className='row align-items-center gap-2 gap-md-0  mb-2'>
                        <div className='col-12 col-md-5 col-lg-7 col-xl-9'>
                            <h3 className="font_18 fw_600 mb-0 text-black py-2">
                                API Hit Details
                            </h3>
                        </div>
                        <div className='col-12 col-md-3 col-lg-2 col-xl-1'>
                            <div className='w-100'>
                                <button className="btn px_btn btn-master-line px-3 py-2 rounded fw_500 font_12 w-100" onClick={handleClear} >Clear</button>
                            </div>
                        </div>
                        <div className='col-12 col-md-4 col-lg-3 col-xl-2'>
                            <div className=' w-100'>
                                
                                <button className={` ${tabelData?.length ? " " : "btn-disable"}  btn px_btn btn-master-line px-4 py-2 rounded fw_500 font_12 w-100`}  onClick={handleDownload} >Export report</button>
                            </div>
                        </div>
                    </div>
                    <div className='row  align-items-center justify-content-end'>
                        <div className={` ${isVisible ? " " : " "}  col-12`}>
                            <div className='align-items-center d-flex flex-column flex-md-row gap-2'>
                                <div className='d-flex flex-column w-100'>
                                    <span className='font_14 fw_500 ws_nowrp'  >
                                        Accounts
                                    </span>
                                    <select className="form-select rounded font_12" onChange={handleClient} >
                                        {clientsNameList?.map((itm) => (
                                            <option key={itm.id} value={itm.id}>{itm.name}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className='d-flex flex-column w-100'>
                                    <span className='font_14 fw_500 ws_nowrp' >
                                        Services
                                    </span>
                                    <select className="form-select rounded font_12" onChange={handleService}>
                                        {serviceNameList?.map((itm) => (
                                            <option value={itm.id}>{itm.serviceName}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className='d-flex flex-column w-100'>
                                    <span className='font_14 fw_500 ws_nowrp'>
                                        Duration
                                    </span>
                                    <select className="form-select rounded font_12" onChange={handleDateselect} value={currentdate} >
                                        {timeIntervals?.map((itm) => (
                                            <option key={itm.id} value={itm.id}>{itm.name}</option>
                                        ))}
                                    </select>
                                </div>
                                {isVisible &&
                                    <>
                                        <div className='d-flex flex-column  w-100'>
                                            <span className='font_14 fw_500 ws_nowrp'  >
                                                Date
                                            </span>
                                            <div className='d-flex gap-2'>
                                                <div className='arco_rangepicker '>
                                                    {/* <DatePicker status='warning' placeholder='warning status' style={{ width: 200 }} /> */}
                                                    <DatePicker.RangePicker onChange={onDateRangeChange}
                                                        style={{
                                                            width: "",
                                                            borderColor: "#ced4da",
                                                            backgroundColor: "transparent",
                                                        }} value={dateRange} 
                                                        disabledDate={(current) => current.isAfter(dayjs())}
                                                        />

                                                </div>
                                                <div className=''>
                                                    <button className="btn px_btn btn-master px-3 py-2 rounded fw_500 font_12 w-100" onClick={handleFilter}>Filter</button>
                                                </div>
                                            </div>
                                        </div>             </>}
                            </div>
                        </div>
                    </div>
                </div>
                <div className='mb-3'>
                    <div className='row'>

                        <div className='col-12 col-md-6 col-lg-3 mb-3'>
                            <Card>
                                <Card.Header className='bg_chart_success border-0 fw_500 text-center text-white' style={{ backgroundColor: 'var(--mastercolor2)' }}>200 HTTP STATUS</Card.Header>
                                <Card.Body className='p-2'>
                                    <div className='text-center font_16'>
                                        {statusCodeValues[200] || 0}
                                    </div>
                                </Card.Body>
                            </Card>
                        </div>
                        <div className='col-12 col-md-6 col-lg-3 mb-3'>
                            <Card>
                                <Card.Header className='bg_chart_success border-0 fw_500 text-center text-white' style={{ backgroundColor: 'var(--mastercolor2)' }}>406 HTTP STATUS</Card.Header>
                                <Card.Body className='p-2'>
                                    <div className='text-center font_16'>
                                        {statusCodeValues[406] || 0}
                                    </div>
                                </Card.Body>
                            </Card>
                        </div>
                        <div className='col-12 col-md-6 col-lg-3 mb-3'>
                            <Card>
                                <Card.Header className='bg_chart_success border-0 fw_500 text-center text-white' style={{ backgroundColor: 'var(--mastercolor2)' }}>409 HTTP STATUS</Card.Header>
                                <Card.Body className='p-2'>
                                    <div className='text-center font_16'>
                                        {statusCodeValues[409] || 0}
                                    </div>
                                </Card.Body>
                            </Card>
                        </div>
                        <div className='col-12 col-md-6 col-lg-3 mb-3'>
                            <Card>
                                <Card.Header className='bg_chart_success border-0 fw_500 text-center text-white' style={{ backgroundColor: 'var(--mastercolor2)' }}>422 HTTP STATUS</Card.Header>
                                <Card.Body className='p-2'>
                                    <div className='text-center font_16'>
                                        {statusCodeValues[422] || 0}
                                    </div>
                                </Card.Body>
                            </Card>
                        </div>

                        {/* <div className='col-12 col-md-6 col-lg-3 mb-3'>
              <Card>
                <Card.Header className='bg_chart_decline border-0 fw_500 text-center text-white'>200 HTTP STATUS</Card.Header>
                <Card.Body className='p-2'>
                  <div className='text-center font_16'>
                    content here..
                  </div>
                </Card.Body>
              </Card>
            </div>
            <div className='col-12 col-md-6 col-lg-3 mb-3'>
              <Card>
                <Card.Header className='bg_chart_pink border-0 fw_500 text-center text-white'>200 HTTP STATUS</Card.Header>
                <Card.Body className='p-2'>
                  <div className='text-center font_16'>
                    content here..
                  </div>
                </Card.Body>
              </Card>
            </div>
            <div className='col-12 col-md-6 col-lg-3 mb-3'>
              <Card>
                <Card.Header className='bg_chart_danger border-0 fw_500 text-center text-white'>200 HTTP STATUS</Card.Header>
                <Card.Body className='p-2'>
                  <div className='text-center font_16'>
                    content here..
                  </div>
                </Card.Body>
              </Card>
            </div> */}
                    </div>
                </div>
                <div className='mb-4'>
                    <div className='border shadow_sm p-2 rounded'>
                        {/* <div className="table_type02 table-responsive custom_scroll1">
              <table className="table table-bordered pb-2 mb-0 bg-white rounded-2 border font_13 valign_middle">
                <thead className="bg_master2 text-white">
                  <tr>
                    <th className="fw_500">Status Code</th>
                    <th className="fw_500">API Call</th>
                    <th className="fw_500">Number of Execution</th>
                    <th className="fw_500">Number of Pages</th>
                  </tr>
                </thead>
                <tbody>
                  {//console.log(tabelData)}

                  {tabelData.map(row => (
                    <tr key={row.Index}>
                      <td>{row.statuscode}</td>
                      <td>{row.apicall}</td>
                      <td>{row.noofexecution}</td>
                      <td>{row.noofpage}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div> */}

                        {/* {//console.log('statuscodechart--->', statusCodeChart)} */}
                        <DataTable
                            columnData={columns}
                            rowData={tabelData}
                            current={currentPage}
                            loading={TableLoader}
                            total={tabelData.length}
                            onChangeTable={onChangeTable}
                        />
                    </div>
                </div>
                {/* {//console.log(tabelData)} */}
                <div className='mb-3 d-none'>
                    <div>
                        <div className='mx-0 row'>
                            {statusCodeChart?.slice(0, 4).map(item =>
                                //console.log({ item }) ||

                                <div className='col-12 col-md-6 mb-3'>
                                    <div className='bg_light2 p-3 border br_5 overflow-hidden'>
                                        <h3 className='fw_600 font_15 text_master2 text-center me-5 pe-5 mb-3 pt-2'>{`Month Wise Count ${item.code} `}</h3>
                                        {/* </div> */}
                                        {/* {//console.log(statusCodeChart)} */}
                                        {/* <div> */}
                                        <PieChart serie={item.data.map(item => item.statuscount)} labeld={item.data.map(item => item.month)} />
                                    </div>
                                </div>
                            )}
                            {/* <div className='col-12 col-md-6 mb-3'>
                                <div>
                                    <h3 className='fw_600 font_18 text_master2 text-center mb-3 pt-2'>Month Wise Count 406</h3>
                                </div>
                                <div>
                                    <PieChart />
                                </div>
                            </div>
                            <div className='col-12 col-md-6 mb-3'>
                                <div>
                                    <h3 className='fw_600 font_18 text_master2 text-center mb-3 pt-2'>Month Wise Count 409</h3>
                                </div>
                                <div>
                                    <PieChart />
                                </div>
                            </div>
                            <div className='col-12 col-md-6 mb-3'>
                                <div>
                                    <h3 className='fw_600 font_18 text_master2 text-center mb-3 pt-2'>Month Wise Count 422</h3>
                                </div>
                                <div>
                                    <PieChart />
                                </div>
                            </div> */}
                        </div>
                    </div>
                </div>
                <div className='mb-3 d-none'>
                    <h3 className='fw_600 font_18 text_master2 text-center mb-3 pt-2 '>Client Hit Count</h3>
                    <div className='border bg_master text-center p-3 fw_600 text-white rounded font_24'>{clientHits}</div>
                </div>
                <div className='mb-3 d-none'>
                    <div>
                        <div className='mx-0 row'>
                            <div className='col-12 col-md-6 '>
                                <div className='bg_light2 p-3 border br_5 overflow-hidden'>
                                    <h3 className='fw_600 font_15 text_master2 text-center me-5 mb-3 pt-2'>CLIENT HIT COUNT</h3>
                                    <div>
                                        <PieChart serie={Object.values(StatusCount)} />
                                    </div>
                                </div>
                            </div>

                            <div className='col-12 col-md-6'>
                                <div className='bg_light2 p-3 border br_5 overflow-hidden'>
                                    <h3 className='fw_600 font_15 text_master2 text-center me-5 pe-5 mb-3 pt-2'>TOP SERVICES</h3>
                                    {serviceNames !== undefined && <div className='ps-4'>
                                        <PieChart labeld={serviceNames} serie={counts} />
                                    </div>}
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div className='mb-3 d-none'>
                    <h3 className='fw_600 font_18 text_master2 text-center mb-3 pt-2'>Last 12 Months count</h3>
                    <div className='border shadow_sm p-2 rounded'>
                        <Chart categorie={categories} serie={series} />
                    </div>
                </div>
            </div >
        </>
    )
}

export default HitOverview
